import { type ReactNode, createContext, useContext, useState } from "react";

export enum HighlightType {
  MAP = 0,
  PLOT = 1,
  ENERGY_PLOT = 2,
  COUNTRY_PLOT = 3,
  WEATHER_TABLE = 4,
  TEPHIGRAM = 5,
  NOTE = 6,
  LOCATION_TABLE = 7,
  CROSS_SECTION = 8,
}

export type HighlightedCell = {
  type: HighlightType;
  id: number;
};

type HighlightContextType = {
  /**
   * Active highlight (hover takes precedence over pinned).
   */
  highlighted?: HighlightedCell;
  hovered?: HighlightedCell;
  pinned?: HighlightedCell;
  setHighlighted: (cell: HighlightedCell | undefined) => void;
  setPinnedHighlighted: (cell: HighlightedCell | undefined) => void;
};

type GridCellHighlightProviderProps = {
  children?: ReactNode;
};

const HighlightContext = createContext<HighlightContextType>({
  setPinnedHighlighted: (_value) => {},
  setHighlighted: (_value) => {},
});

const GridCellHighlightProvider = ({ children }: GridCellHighlightProviderProps) => {
  const [hovered, setHovered] = useState<HighlightedCell>();
  const [pinned, setPinned] = useState<HighlightedCell>();
  const highlighted = hovered ?? pinned;

  return (
    <HighlightContext.Provider
      value={{
        highlighted,
        hovered,
        pinned,
        setHighlighted: setHovered,
        setPinnedHighlighted: setPinned,
      }}
    >
      {children}
    </HighlightContext.Provider>
  );
};

const useActiveGridHighlight = () => useContext(HighlightContext);

export { GridCellHighlightProvider, useActiveGridHighlight };
